<footer class="lp-footer" id="contact">
  <div class="footer-main">
    <div class="container">
      <div class="footer-grid">

        <!-- Brand -->
        <div class="footer-brand">
          <img src="assets/images/dropaddy-logo.svg" alt="DropAddy" class="footer-logo" />
          <p>The most playful way to find meaningful connections and build lasting relationships.</p>
          <div class="social-icons">
            <a href="#" class="social-icon social-fb" aria-label="Facebook">
              <i class="fa-brands fa-facebook-f"></i>
            </a>
            <a href="#" class="social-icon social-ig" aria-label="Instagram">
              <i class="fa-brands fa-instagram"></i>
            </a>
            <a href="#" class="social-icon social-x" aria-label="X">
              <i class="fa-brands fa-x-twitter"></i>
            </a>
          </div>
        </div>

        <!-- Quick Links -->
        <div class="footer-col">
          <h6 class="footer-col-title">Quick Links</h6>
          <div class="footer-links">
            <a href="#features" class="footer-link">Features</a>
            <a href="#app-preview" class="footer-link">How it Works</a>
            <a href="#" class="footer-link">Download</a>
            <a href="#" class="footer-link">Report Bugs</a>
          </div>
        </div>

        <!-- Get in Touch -->
        <div class="footer-col">
          <h6 class="footer-col-title">Get in Touch</h6>
          <div class="contact-items">
            <div class="contact-item">
              <span class="contact-icon"><i class="fa-regular fa-envelope"></i></span>
              <span>hello&#64;poptheballon.com</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon"><i class="fa-solid fa-phone"></i></span>
              <span>+1 (555) 123-4567</span>
            </div>
            <div class="contact-item">
              <span class="contact-icon"><i class="fa-solid fa-globe"></i></span>
              <span>Contact Support</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="footer-bottom">
    <div class="container">
      <div class="footer-bottom-inner">
        <p>© {{ currentYear }} DropAddy. All rights reserved.</p>
        <div class="footer-legal">
          <a href="/privacy" class="legal-link">Privacy Policy</a>
          <span class="sep">|</span>
          <a href="/terms" class="legal-link">Terms of Service</a>
          <span class="sep">|</span>
          <a href="/cookie-policy" class="legal-link">Cookie Policy</a>
        </div>
      </div>
    </div>
  </div>
</footer>
